<template>
    <div id="datatable-campaign-performance">
        <v-data-table
            :headers="headers"
            :items="listPerformances"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50]
            }"
            dense
        >
            <template v-slot:[`item.viewed`]="{ item }">
                <img
                    style="max-height: 50px"
                    :src="
                        item.viewed
                            ? '/images/_SVGs/performance-check.svg'
                            : '/images/_SVGs/performance-close.svg'
                    "
                />
            </template>
            <template v-slot:[`item.downloaded`]="{ item }">
                <img
                    style="max-height: 50px"
                    :src="
                        item.downloaded
                            ? '/images/_SVGs/performance-check.svg'
                            : '/images/_SVGs/performance-close.svg'
                    "
                />
            </template>
            <template v-slot:[`item.forwarded`]="{ item }">
                <img
                    style="max-height: 50px"
                    :src="
                        item.forwarded
                            ? '/images/_SVGs/performance-check.svg'
                            : '/images/_SVGs/performance-close.svg'
                    "
                />
            </template>
            <template v-slot:[`item.modified`]="{ item }">
                <img
                    style="max-height: 50px"
                    :src="
                        item.modified
                            ? '/images/_SVGs/performance-check.svg'
                            : '/images/_SVGs/performance-close.svg'
                    "
                />
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listPerformances: Array | Object,
        totalItems: Number | String,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t("b2b.promo-engine.recipient"),
                    align: "start",
                    value: "entityName",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.visualize"),
                    align: "start",
                    value: "viewed",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.download"),
                    align: "start",
                    value: "downloaded",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.modify"),
                    align: "start",
                    value: "modified",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.forward"),
                    align: "start",
                    value: "forwarded",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
    },
    methods: {},
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-campaign-performance {
    tr {
        height: 42px;
    }
}
</style>
